module.exports = __webpack_public_path__ + "static/bg_top.926a6586.jpg";